const Config = {
  apiKey: 'AIzaSyAa9XPPsomftymXCCaV-jb8pTuja5y0eMM',
  authDomain: 'contraportal-2ec72.firebaseapp.com',
  databaseURL: 'https://contraportal-2ec72.firebaseio.com',
  projectId: 'contraportal-2ec72',
  storageBucket: 'contraportal-2ec72.appspot.com',
  messagingSenderId: '593630355513',
};

const apiKey = 'QnJTvHIX6p0w5a5mq1rioHXu0jFExbBVYIY5tEf8';
const cityKey = 'c244ccb8ff916245240c3b713df82875190fad90';
export {Config, apiKey, cityKey};



// WEBPACK FOOTER //
// ./src/config.js